import { ROLE_REPORTING_ADMIN } from '~/consts/roles';

import isProd from './isProd';

export function canAccessLeLens(user: { roles?: Array<string> } | null | undefined): boolean {
  if (!user) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  return Boolean(user.roles?.includes(ROLE_REPORTING_ADMIN));
}
